import { Fragment } from 'react';
import { Divider, Stack } from '@optimus-web/core';

interface DividedListProps {
    collectionIds: string[];
    renderItem: (id: string) => React.ReactNode;
}

/**
 * Should be equal to height of the heighest companion data column row to align the dividers
 */
const minHeight = '24px';

export const DividedList = ({ collectionIds, renderItem }: DividedListProps) => (
    <Stack spacing="100" vertical>
        {collectionIds.map((id, index) => (
            <Fragment key={id}>
                <Stack style={{ minHeight }}>{renderItem(id)}</Stack>
                {index !== collectionIds.length - 1 ? <Divider /> : null}
            </Fragment>
        ))}
    </Stack>
);
